import { Image } from '@acme/assets';
import { Field, Separator, formatDateTime } from '@acme/foundation';
import { Button } from 'flowbite-react';
export const ApplicationCompletedBanner = ({
  currencySymbol,
  amount,
  amountInRubles,
  completedAt,
  onGoToDocuments,
}: {
  currencySymbol?: string;
  amount?: number | null;
  amountInRubles?: number | null;
  completedAt?: string | null;
  onGoToDocuments?: () => void;
}) => {
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-8">
          <div>
            <Image name="application-end" width={160} height={160} />
          </div>
          <div>
            <p className="text-sm text-gray-600">Заявка исполнена</p>

            <div className="text-gray-900">
              Документы доступны для скачивания
            </div>
          </div>
        </div>
        {onGoToDocuments && (
          <Button color="primary" onClick={onGoToDocuments}>
            Перейти к документам
          </Button>
        )}
      </div>
      <Separator className="-mx-6 my-6" />
      <div className="grid grid-cols-4 gap-x-6 gap-y-1">
        <Field label="Валюта сделки" value={currencySymbol ?? '-'} />

        <Field
          label="Сумма сделки"
          value={amount != null ? amount.toLocaleString('ru-RU') : '-'}
        />
        <Field
          label="Сумма сделки в рублях"
          value={
            amountInRubles != null
              ? amountInRubles.toLocaleString('ru-RU')
              : '-'
          }
        />
        <Field
          label="Завершена"
          value={completedAt ? formatDateTime(completedAt) : '-'}
        />
      </div>
    </>
  );
};
